module.exports = __webpack_public_path__ + "img/4399.2c9b62d2.png";